var map = {
	"./cs.json": 81961,
	"./da.json": 15207,
	"./de.json": 58985,
	"./en-GB.json": 61327,
	"./en.json": 66154,
	"./es.json": 81324,
	"./fr-CA.json": 28763,
	"./fr.json": 15381,
	"./it.json": 76902,
	"./ja.json": 61244,
	"./ko.json": 8022,
	"./nl.json": 19452,
	"./no.json": 11654,
	"./pl.json": 12893,
	"./pt-BR.json": 11066,
	"./sv.json": 87196,
	"./zh-Hans.json": 58074,
	"./zh-Hant.json": 45380
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 84371;